<div class="branch-details">
  <h2 *ngIf="branch.value.id !== 0 || editMode">
    <span id="icon" class="material-icons-outlined">domain</span>
    <span class="title-details">{{ branchTitle | translate }}</span>
  </h2>

  <div *ngIf="BranchEmpty()" class="empty-details">
    <span class="material-icons-outlined">domain</span>
  </div>

  <div *ngIf="branch.value.id !== 0 || editMode" class="branch-info-container">
    <div *ngIf="branch.value.id !== 0 && !editMode" class="branch-info">
      <table>
        <tr class="info-row">
          <td>
            <label>{{ "branchDetails.nameLabel" | translate }}:</label>
          </td>
          <td>
            <span>{{ branch.value.name }}</span>
          </td>
        </tr>
      </table>
      <div *ngIf="supervisor">
        <button class="btn-edit" (click)="toggleEditMode()">
          <span class="material-icons-outlined">edit</span>
          {{ "branchDetails.editButton" | translate }}
        </button>
        <button class="btn-delete" (click)="deleteBranch()">
          <span class="material-icons-outlined">delete</span>
          {{ "branchDetails.deleteButton" | translate }}
        </button>
      </div>

      <messages
        class="message"
        [form]="branchForm"
        [messagesObserver]="messages"
        fieldname="branch"
        [showNonFieldKeys]="TRUE"
        [showFieldName]="TRUE"
        [showFieldKeys]="TRUE"
      ></messages>
    </div>

    <form [formGroup]="branchForm" *ngIf="editMode" class="branch-form">
      <div class="form-group">
        <label for="name">{{ "branchDetails.nameLabel" | translate }}:</label>
        <input type="text" id="name" formControlName="name" />
        <messages
          class="msg"
          [form]="branchForm"
          [messagesObserver]="messages"
          fieldname="name"
        >
        </messages>
      </div>

      <div class="action-buttons">
        <action-button
          (actionEvent)="saveBranch($event)"
          label="{{ 'branchDetails.saveButton' | translate }}"
        >
          <span class="material-icons-outlined">save</span>
          {{ "branchDetails.saveButton" | translate }}
        </action-button>

        <button type="button" class="btn-cancel" (click)="toggleEditMode()">
          <span class="material-icons-outlined">cancel</span>
          {{ "branchDetails.cancelButton" | translate }}
        </button>
      </div>
      <messages
        class="message"
        [form]="branchForm"
        [messagesObserver]="messages"
        fieldname="branch"
        [showNonFieldKeys]="TRUE"
        [showFieldName]="TRUE"
        [showFieldKeys]="TRUE"
      ></messages>
    </form>
  </div>
</div>
